module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ../~/react-modal/lib/index.js
// module id = 374
// module chunks = 0